import { useEffect } from 'react';

import heroFull from '../assets/pictures/sectionimages/joshua-aragon-BMnhuwFYr7w-unsplash.webp';

export default function useProgressiveHeroBg(sectionId, fullSrc = heroFull) {
    useEffect(() => {
        const section = document.getElementById(sectionId);
        if (!section) return undefined;

        let cancelled = false;

        const applyFullImage = () => {
            if (cancelled) return;
            section.style.setProperty('--hero-bg-image', `url("${fullSrc}")`);
            section.classList.add('hero-bg--loaded');
        };

        const loadFullImage = () => {
            const img = new Image();
            img.src = fullSrc;
            if (img.complete) applyFullImage();
            else img.onload = applyFullImage;
        };

        if (document.readyState === 'complete') loadFullImage();
        else window.addEventListener('load', loadFullImage, { once: true });

        return () => {
            cancelled = true;
            window.removeEventListener('load', loadFullImage);
        };
    }, [sectionId, fullSrc]);
}
